export default "__VITE_ASSET__Yh65gSBG__"